import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-school-result',
  templateUrl: './school-result.component.html',
  styleUrls: ['./school-result.component.scss']
})
export class SchoolResultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
